export const RESOURCES_TYPES = {
  // Méta-type : recherche transversale sur toutes les ressources (défaut).
  ALL: 'all',
  // Fonctionnalité / page de l'app — navigue vers la page à la sélection.
  FEATURE: 'feature',
  INVOICE: 'invoice',
  ESTIMATE: 'estimate',
  RECEIPT: 'receipt',
  PAYMENT_RECEIVE: 'payment_receive',
  PAYMENT_MADE: 'payment_made',
  CUSTOMER: 'customer',
  VENDOR: 'vendor',
  ITEM: 'item',
  BILL: 'bill',
  EXPENSE: 'expense',
  MANUAL_JOURNAL: 'manual_journal',
  ACCOUNT: 'account',
  CREDIT_NOTE: 'credit_note',
  VENDOR_CREDIT:'vendor_credit',
  EMPLOYEE: 'employee',
  PAYROLL_RUN: 'payroll_run',
};
